
export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['form'],

  data() {
    return {
      makerOptions: ['Vion Vision', 'TDI', 'Brickstream'],
      modelOptions: ['G5', 'G4', 'G3'],
      serialOptions: ['CB19-7900-BDFC-1794', 'CB19-7900-BDFC-1794', 'CB19-7900-BDFC-1794'],
    };
  }
};
